import React from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { formatNumber } from "@formant/core/common/formatNumber";
import { IEventCounts } from "@formant/core/model/IEventCounts";
import { Icon } from "@formant/ui/component/common/Icon";

import { Button } from "./Button";
import styles from "./EventsButton.scss";

export interface IEventsButtonProps {
    to: string;
    small?: boolean;
    className?: string;
    counts?: IEventCounts;
}

export const EventsButtonPassive = observer(function EventsButton(
    props: IEventsButtonProps,
) {
    const { to, small, className, counts } = props;

    const {
        info,
        warning,
        error,
        critical,
        "triggered-event": triggeredEvents,
        "intervention-request": interventions,
        custom,
        stateful,
    } = {
        info: 0,
        warning: 0,
        error: 0,
        critical: 0,
        "triggered-event": 0,
        "intervention-request": 0,
        custom: 0,
        stateful: 0,
        ...counts,
    };

    const notifications = triggeredEvents + interventions + custom + stateful;
    const intervention = interventions > 0;

    const severity =
        critical > 0
            ? "critical"
            : error > 0
              ? "error"
              : warning > 0
                ? "warning"
                : info > 0
                  ? "info"
                  : undefined;

    const visible = !small || notifications > 0;

    return visible ? (
        <Button
            className={classnames(
                styles["events-button"],
                styles.button,
                intervention && styles.intervention,
                severity && styles[severity],
                small && styles.small,
                visible && styles.visible,
                className,
            )}
            to={to}
            data-tooltip="Notifications"
        >
            {notifications === 0 && <Icon name="event" />}
            {notifications > 0 && formatNumber(notifications)}
        </Button>
    ) : null;
});
